export const INITIAL_INSTRUCTIONS_TITLE = "welcome";
export const LETTERS_TITLE = "correspondence";
export const MAX_ZOOM = 2;
export const MIN_ZOOM = 0.1;
export const ZOOM_STEP = 0.01;
export const INIT_ZOOM = 0.2;

export const LETTERS_URL = "data/Archivepelago v0.2.0 - Letters.csv";
export const PEOPLE_URL = "data/Archivepelago v0.2.0 - People.csv";
export const LINKS_URL = "data/Archivepelago v0.2.0 - LetterLinks.json";